<template>
  <div class="vuetable-filterbar col-md-12">
    <div class="form-group p-l">
      <b-container fluid class="p-a-0">
        <b-row no-gutters>
          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <b-form-datepicker
              locale="pt-br"
              placeholder="Data Inicial"
              v-model="dt_ini"
              reset-button
              class="form-control"
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>
          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <b-form-datepicker
              locale="pt-br"
              placeholder="Data Final"
              v-model="dt_fim"
              reset-button
              class="form-control"
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>
          <b-col sm="6" md="4" class="m-t-5px p-a-0">
            <multiselect
              v-model="transportadora"
              :options-limit="300"
              :limit="2"
              :limit-text="limitText"
              :options="optionsTransportadora"
              track-by="value"
              label="label"
              id="transportadora"
              :hide-selected="true"
              placeholder="Transportadora ( Digite 3 caracteres para pesquisar )"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
              :searchable="true"
              :loading="isLoadingTransportadora"
              @search-change="listaTransportadora"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="4" class="m-t-5px p-a-0">
            <multiselect
                v-model="paramMotivoSelected"
                :options="this.$parent.optionsParamMotivo"
                track-by="parmot_id"
                label="label"
                :hide-selected="true"
                placeholder="Motivo"
                tag-placeholder="Selecionar"
                select-label="Selecionar"
                selected-label="Selecionado"
                deselect-label="Remover"
              ></multiselect>
          </b-col>
          <b-col sm="6" md="4" class="m-t-5px p-a-0">
            <multiselect
                v-model="paramTpOperacaoSelected"
                :options="this.$parent.optionsTpOperacao"
                track-by="value"
                label="label"
                :hide-selected="true"
                placeholder="Tipo Operacao"
                tag-placeholder="Selecionar"
                select-label="Selecionar"
                selected-label="Selecionado"
                deselect-label="Remover"
              ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="carga_ini"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >N° Carga Inicial</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="carga_fim"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >N° Carga Final</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="num_trecho_ini"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >N° do trecho inicial</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="num_trecho_fim"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >N° do trecho final</label
              >
            </div>
          </b-col>

          <!-- <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <multiselect
              v-model="status"
              :options="this.$parent.optionsStatus"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Status"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col> -->
          <b-col sm="6" md="2" class="m-t-5px">
            <div class="input-group-btn">
              <div class="btn-group">
                <button
                  type="button"
                  class="btn btn-secondary btn-outline"
                  @click="doFilter"
                  :disabled="vuetableFilterButton"
                >
                  Filtrar
                </button>
                <button
                  type="button"
                  class="btn btn-secondary btn-outline"
                  @click="resetFilter"
                  :disabled="vuetableFilterButton"
                >
                  Limpar
                </button>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {

  data() {
    return {
      dt_ini: "",
      dt_fim: "",
      transportadora: [],
      carga_ini: "",
      carga_fim: "",
      dt_inicio_label: "",
      dt_fim_label: "",
      num_trecho_ini: "",
      num_trecho_fim: "",
      data_filter: [],
      isLoadingTransportadora: false,
      transportadora: [],
      optionsTransportadora: [],
      paramMotivoSelected: "",
      paramTpOperacaoSelected: "",
      helpForm: new Form({ statusRecord: [], params: [], search: "" }),
    };
  },
  methods: {
    doFilter() {
      this.$store.commit("setVuetableFilterButton", true);
      this.dt_inicio_label = this.dt_ini;
      this.dt_fim_label = this.dt_fim;
      this.dt_ini = this.formatDateSubmit(this.dt_ini);
      this.dt_fim = this.formatDateSubmit(this.dt_fim);
      this.data_filter = {
        dt_ini: this.dt_ini,
        dt_fim: this.dt_fim,
        transportadora: this.transportadora,
        carga_ini: this.carga_ini,
        carga_fim: this.carga_fim,
        num_trecho_ini: this.num_trecho_ini,
        num_trecho_fim: this.num_trecho_fim,
        param_motivo: this.paramMotivoSelected.value,
        tp_operacao: this.paramTpOperacaoSelected.value
      };
      this.$events.fire("filter-set", this.data_filter);
      this.dt_ini = this.dt_inicio_label;
      this.dt_fim = this.dt_fim_label;
    },
    resetFilter() {
      this.dt_ini = ""; // clear the text in text input
      this.dt_fim = "";
      this.transportadora = "";
      this.carga_ini = "";
      this.carga_fim = "";
      this.num_trecho_ini = "";
      this.num_trecho_fim = "";
      this.paramMotivoSelected = "";
      this.paramTpOperacaoSelected = "";
      this.$events.fire("filter-reset");
    },
    formatDateSubmit(value, fmt = "DD/MM/YYYY") {
      return value == null || value == ""
        ? ""
        : moment(value, "YYYY/MM/DD HH:mm").format(fmt);
    },
    listaTransportadora(search) {
      if (search.length >= 3) {
        this.isLoadingTransportadora = true;
        this.helpForm.search = search;
        this.helpForm.status = 1;
        this.helpForm
          .post("/api/pessoa/jsonlist/transportadora")
          .then((response) => {
            this.optionsTransportadora = [];
            new ReturnApi(response, this, true, false, false);
            if (response.items.length > 0) {
              response.items.forEach((obj) => {
                this.optionsTransportadora.push({
                  label:
                    "PJ -" +
                    obj.pessoa.cd +
                    " - " +
                    obj.razao_social +
                    " - " +
                    this.onFormataCnpj(
                      obj.cnpj_base,
                      obj.cnpj_filial,
                      obj.cnpj_digito
                    ).replace(
                      /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
                      "$1.$2.$3/$4-$5"
                    ) +
                    " - " +
                    obj.inscricao_estadual,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            if (response.itemsF.length > 0) {
              response.itemsF.forEach((obj) => {
                this.optionsTransportadora.push({
                  label: "PF -" + obj.nome + " - " + obj.cpf,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            if (response.itemsE.length > 0) {
              response.itemsE.forEach((obj) => {
                this.optionsTransportadora.push({
                  label: "PE -" + obj.nome + " - " + obj.cd,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            this.isLoadingTransportadora = false;
          })
          .catch((errors) => {
            new ReturnApi(errors, this);
          });
      }
    },
    onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      var cnpj_formatado;
      var pad = "00000000";
      var cnpj_base =
        pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
      var pad = "0000";
      var cnpj_filial =
        pad.substring(0, pad.length - cnpj_filial.toString().length) +
        cnpj_filial;
      var pad = "00";
      var cnpj_digito =
        pad.substring(0, pad.length - cnpj_digito.toString().length) +
        cnpj_digito;
      return cnpj_base + "" + cnpj_filial + "" + cnpj_digito;
    },
    limitText(count) {
      return " e ${count} outros clientes";
    },
  },
  computed: {
    vuetableFilterButton: {
      get() {
        return this.$store.state.vuetable.filterButton;
      },
    },
  },
};
</script>
